import loadable from '@loadable/component';

export const OrgDashboardPaymentsListContainerLoadable = loadable(
  () => import('./OrgDashboardPaymentsListContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardPaymentsListContainer,
  },
);
